<form [formGroup]="businessIdentityForm">
    <div class="form-group mb-3">
        <label class="form-label">
            Business Name
            <span class="ms-2" style="cursor: pointer;" placement="top" ngbPopover="Enter the exact legal business name as registered with the EIN, which can be found on the CP 575 EIN Confirmation Letter.">
                <fa-icon [icon]="faQuestionCircle"></fa-icon>
            </span>
        </label>
        <input type="text" class="form-control" formControlName="businessName" placeholder="Appleseed Corporation" [class.is-invalid]="businessName.invalid && (businessName.dirty || businessName.touched)" required>
        @if (businessName.invalid && (businessName.dirty || businessName.touched)) {
        @if (businessName.errors?.['required']) { <div class="input-validation-msg">Business Name is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">
            Business Industry
            <span class="ms-2" style="cursor: pointer;" placement="top" ngbPopover="The industry that most closely matches that of the business.">
                <fa-icon [icon]="faQuestionCircle"></fa-icon>
            </span>
        </label>
        <select class="form-select" formControlName="businessIndustry" [class.is-invalid]="businessIndustry.invalid && (businessIndustry.dirty || businessIndustry.touched)" required>
            <option selected disabled value="SELECT">Select a Business Industry</option>
            @for (businessIndustry of businessIndustryValues; track businessIndustry.value) {
            <option [value]="businessIndustry.value">{{businessIndustry.name}}</option>
            }
        </select>
        @if (businessIndustry.invalid && (businessIndustry.dirty || businessIndustry.touched)) {
        @if (businessIndustry.errors?.['required']) { <div class="input-validation-msg">Business Industry is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Registration Identifier</label>
        <select class="form-select" formControlName="businessRegistrationIdentifier" [class.is-invalid]="businessRegistrationIdentifier.invalid && (businessRegistrationIdentifier.dirty || businessRegistrationIdentifier.touched)" required>
            <option selected disabled value="SELECT">Select a Registration Identifier</option>
            @for (businessRegistrationIdentifier of businessRegistrationIdentifierValues; track businessRegistrationIdentifier.value) {
            <option [value]="businessRegistrationIdentifier.value">{{businessRegistrationIdentifier.name}}</option>
            }
        </select>
        @if (businessRegistrationIdentifier.invalid && (businessRegistrationIdentifier.dirty || businessRegistrationIdentifier.touched)) {
        @if (businessRegistrationIdentifier.errors?.['required']) { <div class="input-validation-msg">Registration Identifier is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Registration Number</label>
        <input type="text" class="form-control" formControlName="businessRegistrationNumber" placeholder="K808227" [class.is-invalid]="businessRegistrationNumber.invalid && (businessRegistrationNumber.dirty || businessRegistrationNumber.touched)" required>
        @if (businessRegistrationNumber.invalid && (businessRegistrationNumber.dirty || businessRegistrationNumber.touched)) {
        @if (businessRegistrationNumber.errors?.['required']) { <div class="input-validation-msg">Registration Number is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Business Type</label>
        <select class="form-select" formControlName="businessType" [class.is-invalid]="businessType.invalid && (businessType.dirty || businessType.touched)" required>
            <option selected disabled value="SELECT">Select a Business Type</option>
            @for (businessType of businessTypeValues; track businessType.value) {
            <option [value]="businessType.value">{{businessType.name}}</option>
            }
        </select>
        @if (businessType.invalid && (businessType.dirty || businessType.touched)) {
        @if (businessType.errors?.['required']) { <div class="input-validation-msg">Business Type is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Social Media Profile URL (Optional)</label>
        <input type="text" class="form-control" formControlName="socialMediaProfileUrls" placeholder="https://www.facebook.com/TinselCRM">
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Website URL (Optional)</label>
        <input type="text" class="form-control" formControlName="websiteUrl" placeholder="https://www.tinselcrm.com">
    </div>
</form>
<button type="button" class="btn btn-primary w-100" (click)="submitForm();" [disabled]="!businessIdentityForm.valid">Next</button>